import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromInvoiceSessionNumber from './invoice-session-number.reducer';

export const selectInvoiceSessionNumberState = createFeatureSelector<fromInvoiceSessionNumber.State>(
    fromInvoiceSessionNumber.invoiceSessionNumbersFeatureKey
);

export const {
    selectIds,
    selectEntities,
    selectAll,
    selectTotal
} = fromInvoiceSessionNumber.adapter.getSelectors(
    selectInvoiceSessionNumberState
);
